/**
 * @generated SignedSource<<86ca6f80c6fdb722cc1f542e32cf7a96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnalyticsTimeResolution = "DAY" | "MONTH" | "QUARTER" | "WEEK";
export type WorkspaceAnalyticsDimensionType = "STORE" | "WORKSPACE_OWNER";
export type WorkspaceAnalyticsMetric = "PRODUCT_DATE_TRACKER_REGISTERED" | "PRODUCT_DATE_TRACKER_TASKS_COMPLETED" | "ROUTINE_OCCASION_COMPLETED" | "TASK_EXECUTIONS_COMPLETED" | "TODO_CREATED" | "TODO_ISSUE_CREATED" | "TODO_ISSUE_RESOLVED" | "TODO_ISSUE_RESOLVED_AVG_TIME" | "TODO_RESOLVED" | "TODO_RESOLVED_AVG_TIME";
export type WorkspaceRoutineAnalyticsDetailQuery$variables = {
  groupByDimension: WorkspaceAnalyticsDimensionType;
  metric: WorkspaceAnalyticsMetric;
  routineId: string;
  timeResolution: AnalyticsTimeResolution;
  workspaceId: string;
};
export type WorkspaceRoutineAnalyticsDetailQuery$data = {
  readonly routine: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineAnalyticsChartAndTable_query">;
};
export type WorkspaceRoutineAnalyticsDetailQuery = {
  response: WorkspaceRoutineAnalyticsDetailQuery$data;
  variables: WorkspaceRoutineAnalyticsDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupByDimension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metric"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeResolution"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "routineId"
    }
  ],
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceRoutineAnalyticsDetailQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "WorkspaceRoutineAnalyticsChartAndTable_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceRoutineAnalyticsDetailQuery",
    "selections": [
      (v6/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "workspaceId"
          }
        ],
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "routineId",
                    "variableName": "routineId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              {
                "kind": "Variable",
                "name": "metric",
                "variableName": "metric"
              }
            ],
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "valueUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "groupByDimension",
                    "variableName": "groupByDimension"
                  },
                  {
                    "kind": "Variable",
                    "name": "timeResolution",
                    "variableName": "timeResolution"
                  }
                ],
                "concreteType": "TimeSeriesAnalyticsConnection",
                "kind": "LinkedField",
                "name": "connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSeriesAnalyticsNodeDimension",
                    "kind": "LinkedField",
                    "name": "dimensions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "label",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSeriesAnalyticsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSeriesAnalyticsNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formattedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSeriesAnalyticsNodeDimensionValue",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dimensionId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3606683adcd7f8894c5e4e1d70defcc",
    "id": null,
    "metadata": {},
    "name": "WorkspaceRoutineAnalyticsDetailQuery",
    "operationKind": "query",
    "text": "query WorkspaceRoutineAnalyticsDetailQuery(\n  $routineId: ID!\n  $workspaceId: ID!\n  $metric: WorkspaceAnalyticsMetric!\n  $groupByDimension: WorkspaceAnalyticsDimensionType!\n  $timeResolution: AnalyticsTimeResolution!\n) {\n  routine(id: $routineId) {\n    id\n    title\n  }\n  ...WorkspaceRoutineAnalyticsChartAndTable_query\n}\n\nfragment TimeSeriesChart on TimeSeriesAnalyticsConnection {\n  dimensions {\n    id\n    label\n    color\n  }\n  edges {\n    node {\n      date\n      formattedDate\n      values {\n        dimensionId\n        value\n      }\n    }\n  }\n}\n\nfragment TimeSeriesChartAndTable_data on TimeSeriesAnalyticsConnection {\n  ...TimeSeriesChart\n  ...TimeSeriesTable\n  dimensions {\n    id\n  }\n}\n\nfragment TimeSeriesTable on TimeSeriesAnalyticsConnection {\n  dimensions {\n    id\n    label\n    color\n  }\n  edges {\n    node {\n      formattedDate\n      values {\n        dimensionId\n        value\n      }\n    }\n  }\n}\n\nfragment WorkspaceRoutineAnalyticsChartAndTable_query on Query {\n  workspace(id: $workspaceId) {\n    analytics(metric: $metric, filter: {routineId: $routineId}) {\n      valueUnit\n      connection(groupByDimension: $groupByDimension, timeResolution: $timeResolution) {\n        ...TimeSeriesChartAndTable_data\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "830d2de04921ec505d5cd062214a049b";

export default node;
